import React, { useState } from 'react'

interface ServiceArea {
  name: string
  frequency: string
  sessions: string
}

export const ProcedureUplift = () => {
  const [templateName, setTemplateName] = useState('')
  const [categoryName, setCategoryName] = useState('')
  const [description, setDescription] = useState('')
  const [serviceAreas, setServiceAreas] = useState<ServiceArea[]>([
    { name: '', frequency: '', sessions: '' },
  ])
  const [monthlyCharges, setMonthlyCharges] = useState('')
  const [monthlyDiscount, setMonthlyDiscount] = useState('')
  const [quarterlyCharges, setQuarterlyCharges] = useState('')
  const [quarterlyDiscount, setQuarterlyDiscount] = useState('')

  const handleAddServiceArea = () => {
    setServiceAreas([...serviceAreas, { name: '', frequency: '', sessions: '' }])
  }

  const handleRemoveServiceArea = (index: number) => {
    setServiceAreas(serviceAreas.filter((_, i) => i !== index))
  }

  const handleServiceAreaChange = (index: number, field: keyof ServiceArea, value: string) => {
    const updated = [...serviceAreas]
    updated[index][field] = value
    setServiceAreas(updated)
  }

  return (
    <div className="section" style={{ width: '100%' }}>
      {/* Header */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <div className="heading">Procedure Uplift</div>
        <button className="outline-bttn">Draft</button>
      </div>

      {/* Create Core Package Section */}
      <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid rgba(226, 232, 240, 0.5)', padding: '24px', marginBottom: '24px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '20px', color: '#222' }}>Create Core Package</h3>

        {/* Template Name & Category */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
          <div>
            <label htmlFor="templateName" style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px', color: '#222' }}>Template Name</label>
            <input
              id="templateName"
              type="text"
              placeholder="Template Name"
              value={templateName}
              onChange={(e) => setTemplateName(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '13px',
                boxSizing: 'border-box',
              }}
            />
          </div>
          <div>
            <label htmlFor="categoryName" style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px', color: '#222' }}>Category Name</label>
            <input
              id="categoryName"
              type="text"
              placeholder="Category Name"
              value={categoryName}
              onChange={(e) => setCategoryName(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '13px',
                boxSizing: 'border-box',
              }}
            />
          </div>
        </div>

        {/* Description */}
        <div style={{ marginBottom: '20px' }}>
          <label htmlFor="description" style={{ display: 'block', fontSize: '13px', fontWeight: 600, marginBottom: '6px', color: '#222' }}>Description</label>
          <textarea
            id="description"
            placeholder="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #e2e8f0',
              borderRadius: '8px',
              fontSize: '13px',
              boxSizing: 'border-box',
              minHeight: '80px',
              fontFamily: 'Quicksand, sans-serif',
            }}
          />
        </div>

        {/* Service Area Section */}
        <div style={{ marginBottom: '20px' }}>
          <h4 style={{ fontSize: '13px', fontWeight: 600, marginBottom: '12px', color: '#222' }}>Service Area</h4>
          {serviceAreas.map((area, index) => {
            const uniqueId = `service-area-item-${area.name || index}`
            const areaId = `area-${uniqueId}-name`
            const freqId = `area-${uniqueId}-freq`
            const sessionId = `area-${uniqueId}-session`
            return (
              <div key={uniqueId} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: '12px', marginBottom: '12px', alignItems: 'flex-end' }}>
                <div>
                  <label htmlFor={areaId} style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '4px' }}>Area Name</label>
                  <input
                    id={areaId}
                    type="text"
                    placeholder="Service Area Name"
                    value={area.name}
                    onChange={(e) => handleServiceAreaChange(index, 'name', e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px 10px',
                      border: '1px solid #e2e8f0',
                      borderRadius: '6px',
                      fontSize: '12px',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>
                <div>
                  <label htmlFor={freqId} style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '4px' }}>Frequency</label>
                  <select
                    id={freqId}
                    value={area.frequency}
                    onChange={(e) => handleServiceAreaChange(index, 'frequency', e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px 10px',
                      border: '1px solid #e2e8f0',
                      borderRadius: '6px',
                      fontSize: '12px',
                      boxSizing: 'border-box',
                    }}
                  >
                    <option value="">Select frequency</option>
                    <option value="daily">Daily</option>
                    <option value="weekly">Weekly</option>
                    <option value="monthly">Monthly</option>
                  </select>
                </div>
                <div>
                  <label htmlFor={sessionId} style={{ fontSize: '11px', color: '#666', display: 'block', marginBottom: '4px' }}>Sessions</label>
                  <input
                    id={sessionId}
                    type="text"
                    placeholder="Sessions"
                    value={area.sessions}
                    onChange={(e) => handleServiceAreaChange(index, 'sessions', e.target.value)}
                    style={{
                      width: '100%',
                      padding: '8px 10px',
                      border: '1px solid #e2e8f0',
                      borderRadius: '6px',
                      fontSize: '12px',
                      boxSizing: 'border-box',
                    }}
                  />
                </div>
                <button
                  onClick={() => handleRemoveServiceArea(index)}
                  aria-label="Remove service area"
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#999',
                    cursor: 'pointer',
                    fontSize: '18px',
                    padding: 0,
                  }}
                >
                  ×
                </button>
              </div>
            )
          })}
          <button
            onClick={handleAddServiceArea}
            style={{
              background: 'none',
              border: 'none',
              color: '#009FF5',
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: '13px',
              marginTop: '8px',
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
            }}
          >
            + Add Service Area
          </button>
        </div>

        {/* Monthly & Quarterly Charges */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
          <div>
            <label htmlFor="monthlyCharges" style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '6px', color: '#222' }}>Monthly Charges</label>
            <input
              id="monthlyCharges"
              type="text"
              placeholder="Monthly Charges"
              value={monthlyCharges}
              onChange={(e) => setMonthlyCharges(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '13px',
                boxSizing: 'border-box',
              }}
            />
          </div>
          <div>
            <label htmlFor="quarterlyCharges" style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '6px', color: '#222' }}>Quarterly Charges</label>
            <input
              id="quarterlyCharges"
              type="text"
              placeholder="Quarterly Charges"
              value={quarterlyCharges}
              onChange={(e) => setQuarterlyCharges(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '13px',
                boxSizing: 'border-box',
              }}
            />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '24px' }}>
          <div>
            <label htmlFor="monthlyDiscount" style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '6px', color: '#222' }}>Discount (%)</label>
            <input
              id="monthlyDiscount"
              type="text"
              placeholder="%"
              value={monthlyDiscount}
              onChange={(e) => setMonthlyDiscount(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '13px',
                boxSizing: 'border-box',
              }}
            />
          </div>
          <div>
            <label htmlFor="quarterlyDiscount" style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '6px', color: '#222' }}>Discount (%)</label>
            <input
              id="quarterlyDiscount"
              type="text"
              placeholder="%"
              value={quarterlyDiscount}
              onChange={(e) => setQuarterlyDiscount(e.target.value)}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '13px',
                boxSizing: 'border-box',
              }}
            />
          </div>
        </div>
      </div>

      {/* HeartGuard Premium Section */}
      <div style={{ background: '#fff', borderRadius: '8px', border: '1px solid rgba(226, 232, 240, 0.5)', padding: '24px', marginBottom: '24px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '20px', color: '#222' }}>HeartGuard Premium</h3>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
          <div>
            <label htmlFor="hgMonthlyCharges" style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '6px', color: '#222' }}>Total Monthly Charges</label>
            <input
              id="hgMonthlyCharges"
              type="text"
              placeholder="Total Monthly Charges"
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '13px',
                boxSizing: 'border-box',
              }}
            />
          </div>
          <div>
            <label htmlFor="hgMonthlyDiscount" style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '6px', color: '#222' }}>Discount</label>
            <input
              id="hgMonthlyDiscount"
              type="text"
              placeholder="%"
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '13px',
                boxSizing: 'border-box',
              }}
            />
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <div>
            <label htmlFor="hgQuarterlyCharges" style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '6px', color: '#222' }}>Total Quarterly Charges</label>
            <input
              id="hgQuarterlyCharges"
              type="text"
              placeholder="Total Quarterly Charges"
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '13px',
                boxSizing: 'border-box',
              }}
            />
          </div>
          <div>
            <label htmlFor="hgQuarterlyDiscount" style={{ fontSize: '13px', fontWeight: 600, display: 'block', marginBottom: '6px', color: '#222' }}>Discount</label>
            <input
              id="hgQuarterlyDiscount"
              type="text"
              placeholder="%"
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #e2e8f0',
                borderRadius: '8px',
                fontSize: '13px',
                boxSizing: 'border-box',
              }}
            />
          </div>
        </div>
      </div>

      {/* Core Package Cards Section */}
      <div style={{ marginBottom: '24px' }}>
        <h3 style={{ fontSize: '16px', fontWeight: 600, marginBottom: '20px', color: '#222' }}>Core Package</h3>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>
          {/* Essential Recovery Card */}
          <div style={{
            background: '#fff',
            borderRadius: '8px',
            border: '1px solid rgba(226, 232, 240, 0.5)',
            padding: '20px',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '16px' }}>
              <h4 style={{ fontSize: '14px', fontWeight: 600, color: '#222', margin: 0 }}>Essential Recovery</h4>
              <span style={{ fontSize: '11px', color: '#666', background: '#f0f4f8', padding: '4px 8px', borderRadius: '4px' }}>5 Include</span>
            </div>

            <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.6', marginBottom: '16px' }}>
              <div>1. Remote Monitoring - Weekly 1</div>
              <div>2. Nurse care - Monthly 1</div>
              <div>3. Telehealth - Monthly 1</div>
              <div>4. Physio sessions - Monthly 1</div>
              <div>5. Medication delivery</div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
              <div>
                <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>5 Handles Monitoring</div>
                <div style={{ fontSize: '13px', fontWeight: 600, color: '#222' }}>$175/mo</div>
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>Discount</div>
                <div style={{ fontSize: '13px', fontWeight: 600, color: '#222' }}>%</div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '8px' }}>
              <button className="outline-bttn" style={{ flex: 1, fontSize: '13px', padding: '8px' }}>Save Draft</button>
              <button style={{
                flex: 1,
                background: '#EF4444',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '8px',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer',
              }}>Delete</button>
            </div>
          </div>

          {/* Cardiac Care+ Card */}
          <div style={{
            background: '#fff',
            borderRadius: '8px',
            border: '1px solid rgba(226, 232, 240, 0.5)',
            padding: '20px',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom: '16px' }}>
              <h4 style={{ fontSize: '14px', fontWeight: 600, color: '#222', margin: 0 }}>Cardiac Care+</h4>
              <span style={{ fontSize: '11px', color: '#fff', background: '#EC4899', padding: '4px 8px', borderRadius: '4px' }}>6 Include</span>
            </div>

            <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.6', marginBottom: '16px' }}>
              <div>1. Remote Monitoring - Weekly 2</div>
              <div>2. Nurse care - Monthly 2</div>
              <div>3. Telehealth - Monthly 2</div>
              <div>4. Physio sessions - Monthly 2</div>
              <div>5. Medication delivery</div>
              <div>6. Medication delivery</div>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '16px' }}>
              <div>
                <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>Best for most post CARO patients</div>
                <div style={{ fontSize: '13px', fontWeight: 600, color: '#222' }}>$299/mo</div>
              </div>
              <div>
                <div style={{ fontSize: '11px', color: '#666', marginBottom: '4px' }}>Discount</div>
                <div style={{ fontSize: '13px', fontWeight: 600, color: '#222' }}>%</div>
              </div>
            </div>

            <div style={{ display: 'flex', gap: '8px' }}>
              <button className="outline-bttn" style={{ flex: 1, fontSize: '13px', padding: '8px' }}>Save Draft</button>
              <button style={{
                flex: 1,
                background: '#EC4899',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '8px',
                fontSize: '13px',
                fontWeight: 600,
                cursor: 'pointer',
              }}>Delete</button>
            </div>
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
        <button className="outline-bttn">Save Draft</button>
        <button style={{
          background: '#009FF5',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          padding: '12px 24px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
        }}>Publish Template</button>
      </div>
    </div>
  )
}
